import { IEnvironmentConfig } from './environment.interface';

export const environment: IEnvironmentConfig = {
  loginUrl: 'https://iam.dev.kerberos.vision/auth/realms/development/protocol/openid-connect/auth',
  production: false,
  flattenTranslations: false,
  backendUrl: 'https://kyc-admin-bff.dev.kerberos.vision/',
};
